import React from 'react';
import {Glyphicon} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';
import {isAuthenticated} from "../firebase";
import {connect} from "react-redux";

const NavLinkHideSidebar = (props) => (
    <NavLink {...props} onClick={() => document.getElementById("sidebar-layout-obfuscator").click()} />
);

class Sidebar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            admin: false
        };
    }

    render() {
        const {user} = this.props;

        return (
            <aside className="sidebar-container">
                <div className="sidebar-header">
                    <div className="sidebar-header-logo">
                        {this.props.team && this.props.team.name}
                    </div>
                </div>
                <div className="sidebar-content">
                    { isAuthenticated() && (
                        <nav className="sidebar-nav">
                            <ul>
                                <li>
                                    <NavLinkHideSidebar
                                        to=""
                                        exact
                                        activeClassName="selected">
                                        <Glyphicon glyph="plus"/> Report hours
                                    </NavLinkHideSidebar>
                                </li>
                                <li>
                                    <NavLinkHideSidebar
                                        to="/projects"
                                        exact
                                        activeClassName="selected">
                                        <Glyphicon glyph="th-list"/> Projects
                                    </NavLinkHideSidebar>
                                </li>
                                {user.admin && (
                                    <li>
                                        <NavLinkHideSidebar
                                            to="/team"
                                            activeClassName="selected">
                                            <Glyphicon glyph="user"/> Team Management
                                        </NavLinkHideSidebar>
                                    </li>
                                )}
                            </ul>
                        </nav>
                    )}
                </div>
            </aside>
        )
    }
};

export default connect(state => ({
    user: state.users.active,
    team: state.users.active ? state.users.active.team : null
}))(Sidebar);


// WEBPACK FOOTER //
// ./src/layout/Sidebar.js